import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { WishlistAvailabilitySearch } from "./component";
import {
  getAdultsCount,
  getChildren,
  getFromDate,
  getPetsCount,
  getRoomsCount,
  getUntilDate,
} from "../../../search/reducer";
import {
  areRequestParametersChanged,
  getFilteredAndSortedHotelAvailabilityLodgings,
} from "../../../availability/reducer";
import { IStoreState } from "../../../../reducers/types";

const mapStateToProps = (state: IStoreState) => ({
  fromDate: getFromDate(state),
  untilDate: getUntilDate(state),
  adultsCount: getAdultsCount(state),
  childrenAges: getChildren(state),
  petsCount: getPetsCount(state),
  roomsCount: getRoomsCount(state),
  areRequestParametersChanged: areRequestParametersChanged(state),
  lodgings: getFilteredAndSortedHotelAvailabilityLodgings(state),
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type WishlistAvailabilitySearchConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedWishlistAvailabilitySearch = withRouter(
  connector(WishlistAvailabilitySearch)
);
